/**
 * Copyright ©2024 Drivepoint
 */

import {createElement} from "react";
import * as MuiIcons from "@mui/icons-material/index";

export type DPIconName = keyof typeof MuiIcons;

export type DPIconProps = {
  iconName: DPIconName;
  style?: React.CSSProperties
};

export default function DPIcon({iconName, style = {}}: DPIconProps) {
  const IconComponent = MuiIcons[iconName];
  if (!IconComponent) { return null; }
  return createElement(IconComponent, {style});
}
